<app-header-home></app-header-home>
<section>
  <div class="container-fluid">
    <div class="row justify-content-center align-items-center text-center">
      <div class="col-auto">
        <div class="description-header d-flex flex-column align-items-center gap-2 gap-md-3">
          <h1 class="fs-5 mb-0 fw-normal"><strong class="fw-normal text-danger">Seguro de Personas</strong></h1>
          <p class="fw-normal fs-5" style="max-width: 490px;">Sabemos que hay conversaciones difíciles. Resolver tu
            tranquilidad y la de los tuyos hoy toma solo 5 minutos.</p>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="position-relative">
  <div class="align-items-center bottom-0 d-flex end-0 h-100 m-auto position-absolute start-0 top-0"
    style="pointer-events: none;">
    <hr class="w-100 border-2 border opacity-20">
  </div>
  <div class="container-fluid">
    <div class="row justify-content-center text-center">
      <div class="col-12">
        <h2 class="fs-3 text-primary mb-4 mt-2">¿Qué tipo de protección necesitas?</h2>
      </div>
    </div>
    <div class="row justify-content-center hstack py-4 g-3 g-sm-4">
      <div class="col-6 col-sm-auto" style="max-width: 280px;">
        <button type="button"
          class="card text-dark item-category-lines overflow-hidden border-2 px-0 item-transition border-white rounded-5 shadow border"
          (click)="selectInsuranceCategory(Category.Life)">
          <div class="indicator_card rounded-bottom-4 border-bottom border-start border-end mx-auto item-transition">
          </div>
          <div class="card-body py-3 px-3 px-md-4 gap-3 d-flex flex-column align-items-center text-center">
            <div class="icon-group">
              <app-icon name="vida" [size]="80" [strokeWidth]="1.2" color="#ce343c"></app-icon>
            </div>
            <h3 class="card-title text-dark fw-semibold text-uppercase lh-sm m-0 small"><strong
                class="fw-semibold d-block">Seguro</strong> de Vida</h3>
            <p class="small m-0 text-center text-secondary lh-sm">
              Protección económica para tu familia en caso de fallecimiento.
            </p>
            <div
              class="item-category-btn text-dark small item-transition border bg-transparent d-flex align-items-center gap-1 ps-2 ps-md-3 pe-2 pe-md-2 py-1 py-md-2 rounded-pill fw-semibold text-secondary">
              Comenzar
              <app-icon name="chevron-right" [size]="18" [strokeWidth]="1.2"></app-icon>
            </div>
          </div>
        </button>
      </div>
      <div class="col-6 col-sm-auto" style="max-width: 280px;">
        <button type="button"
          class="card text-dark item-category-lines overflow-hidden border-2 px-0 item-transition border-white rounded-5 shadow border"
          (click)="selectInsuranceCategory(Category.Health)">
          <div class="indicator_card rounded-bottom-4 border-bottom border-start border-end mx-auto item-transition">
          </div>
          <div class="card-body py-3 px-3 px-md-4 gap-3 d-flex flex-column align-items-center text-center">
            <div class="icon-group">
              <app-icon name="enfermedades-graves" [size]="80" [strokeWidth]="1.2" color="#ce343c"></app-icon>
            </div>
            <h3 class="card-title text-dark fw-semibold text-uppercase lh-sm m-0 small">
              <strong class="fw-semibold d-block">Seguro</strong> de Salud
            </h3>
            <p class="small m-0 text-center text-secondary lh-sm">
              Cobertura ante enfermedades graves y gastos médicos.
            </p>
            <div
              class="item-category-btn text-dark small item-transition border bg-transparent d-flex align-items-center gap-1 ps-2 ps-md-3 pe-2 pe-md-2 py-1 py-md-2 rounded-pill fw-semibold text-secondary">
              Comenzar
              <app-icon name="chevron-right" [size]="18" [strokeWidth]="1.2"></app-icon>
            </div>
          </div>
        </button>
      </div>
      <div class="col-6 col-sm-auto" style="max-width: 280px;">
        <button type="button"
          class="card text-dark item-category-lines overflow-hidden px-0 border-2 item-transition border-white rounded-5 shadow border"
          (click)="selectInsuranceCategory(Category.Accident)">
          <div class="indicator_card rounded-bottom-4 border-bottom border-start border-end mx-auto item-transition">
          </div>
          <div class="card-body py-3 px-3 px-md-4 gap-3 d-flex flex-column align-items-center text-center">
            <div class="icon-group">
              <app-icon name="accidentes-personales" [size]="80" [strokeWidth]="1.2" color="#ce343c"></app-icon>
            </div>
            <h3 class="card-title text-dark fw-semibold text-uppercase lh-sm m-0 small"><strong
                class="fw-semibold d-block">Accidentes</strong> Personales</h3>
            <p class="small m-0 text-center text-secondary lh-sm">
              Respaldo económico ante accidentes e invalidez.
            </p>
            <div
              class="item-category-btn text-dark small item-transition border bg-transparent d-flex align-items-center gap-1 ps-2 ps-md-3 pe-2 pe-md-2 py-1 py-md-2 rounded-pill fw-semibold text-secondary">
              Comenzar
              <app-icon name="chevron-right" [size]="18" [strokeWidth]="1.2"></app-icon>
            </div>
          </div>

        </button>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <p class="text-center mt-4 text-muted fs-5 d-flex flex-column align-items-center gap-3">
          ¿Ya tienes una cotización?
          <button type="button" class="btn btn-outline-danger rounded-pill px-3" (click)="openQuoteModal()">Consulta
            cotización</button>
        </p>
      </div>
    </div>
  </div>
</section>
@if (showQuoteModal) {
<div class="modal fade show d-block" tabindex="-1" role="dialog" aria-modal="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content rounded-5">
      <div class="modal-header pb-0 border-0">
        <figure class="logo-header-modal m-0" style="width: 190px; height: 40px;">
          <img class="w-100 h-100 object-fit-contain" src="../../../../assets/img/logo-la_colonialR.png" alt="">
        </figure>
        <button type="button" class="btn-close" aria-label="Cerrar" (click)="closeQuoteModal()"></button>
      </div>
      <div class="modal-body">
        <h5 class="modal-title mb-2">Consultar cotización existente</h5>
        <form [formGroup]="form" (ngSubmit)="onSearchQuote()" novalidate>
          <div class="form-floating mb-2">
            <input id="quoteNumberInput" class="form-control" type="text" formControlName="quoteNumber" placeholder=" ">
            <label for="quoteNumberInput">Número de cotización</label>
          </div>
          <div class="form-floating mb-3">
            <input id="quoteEmailInput" class="form-control" type="email" formControlName="quoteEmail" placeholder=" ">
            <label for="quoteEmailInput">Correo electrónico</label>
          </div>
          <div class="d-flex justify-content-start gap-2">
            <button type="submit" class="btn btn-danger bg-danger rounded-pill" [disabled]="form.invalid">Buscar
              cotización</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<div class="modal-backdrop fade show" (click)="closeQuoteModal()"></div>
}
@if (isLoggedIn) {
<section class="retail-bar small justify-content-center mt-2 mb-3 d-flex position-sticky sticky-bottom"
  style="pointer-events: none;">
  <div
    class="rounded-pill small py-1 px-2  bg-opacity-75 align-items-center gap-2 mb-1 shadow border-white border d-flex rounded-pill bg-dark text-white align-items-center gap-2">
    <app-icon name="user-star" [size]="18" [strokeWidth]="1.2" color="#fff"></app-icon>
    {{ userFullName }}
  </div>
</section>
}
<footer class="border-top py-4">
  <div class="container-fluid">
    <div class="row justify-content-center row-cols-1 row-cols-lg-3 g-4">
      <div class="col">
        <p class="text-center text-secondary mb-1">
          Síguenos en las redes
        </p>
        <div class="d-flex  align-items-center justify-content-center link-socials gap-1 mt-2">
          <a href="https://www.facebook.com/lacolonialseguros"
            class="text-secondary text-decoration-none bg-danger d-flex p-0 align-items-center justify-content-center rounded-circle"
            style="width: 34px; height: 34px;" target="_blank">
            <svg role="img" viewBox="0 0 24 24" style="width: 18px; height:18px;" xmlns="http://www.w3.org/2000/svg">
              <title>Facebook</title>
              <path fill="#fff"
                d="M9.101 23.691v-7.98H6.627v-3.667h2.474v-1.58c0-4.085 1.848-5.978 5.858-5.978.401 0 .955.042 1.468.103a8.68 8.68 0 0 1 1.141.195v3.325a8.623 8.623 0 0 0-.653-.036 26.805 26.805 0 0 0-.733-.009c-.707 0-1.259.096-1.675.309a1.686 1.686 0 0 0-.679.622c-.258.42-.374.995-.374 1.752v1.297h3.919l-.386 2.103-.287 1.564h-3.246v8.245C19.396 23.238 24 18.179 24 12.044c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.628 3.874 10.35 9.101 11.647Z" />
            </svg>
          </a>
          <a href="https://www.instagram.com/lacolonialseg/"
            class="text-secondary text-decoration-none bg-danger d-flex p-0 align-items-center justify-content-center rounded-circle"
            style="width: 34px; height: 34px;" target="_blank">
            <svg role="img" viewBox="0 0 24 24" style="width: 18px; height:18px;" xmlns="http://www.w3.org/2000/svg">
              <title>Instagram</title>
              <path fill="#fff"
                d="M7.0301.084c-1.2768.0602-2.1487.264-2.911.5634-.7888.3075-1.4575.72-2.1228 1.3877-.6652.6677-1.075 1.3368-1.3802 2.127-.2954.7638-.4956 1.6365-.552 2.914-.0564 1.2775-.0689 1.6882-.0626 4.947.0062 3.2586.0206 3.6671.0825 4.9473.061 1.2765.264 2.1482.5635 2.9107.308.7889.72 1.4573 1.388 2.1228.6679.6655 1.3365 1.0743 2.1285 1.38.7632.295 1.6361.4961 2.9134.552 1.2773.056 1.6884.069 4.9462.0627 3.2578-.0062 3.668-.0207 4.9478-.0814 1.28-.0607 2.147-.2652 2.9098-.5633.7889-.3086 1.4578-.72 2.1228-1.3881.665-.6682 1.0745-1.3378 1.3795-2.1284.2957-.7632.4966-1.636.552-2.9124.056-1.2809.0692-1.6898.063-4.948-.0063-3.2583-.021-3.6668-.0817-4.9465-.0607-1.2797-.264-2.1487-.5633-2.9117-.3084-.7889-.72-1.4568-1.3876-2.1228C21.2982 1.33 20.628.9208 19.8378.6165 19.074.321 18.2017.1197 16.9244.0645 15.6471.0093 15.236-.005 11.977.0014 8.718.0076 8.31.0215 7.0301.0839m.1402 21.6932c-1.17-.0509-1.8053-.2453-2.2287-.408-.5606-.216-.96-.4771-1.3819-.895-.422-.4178-.6811-.8186-.9-1.378-.1644-.4234-.3624-1.058-.4171-2.228-.0595-1.2645-.072-1.6442-.079-4.848-.007-3.2037.0053-3.583.0607-4.848.05-1.169.2456-1.805.408-2.2282.216-.5613.4762-.96.895-1.3816.4188-.4217.8184-.6814 1.3783-.9003.423-.1651 1.0575-.3614 2.227-.4171 1.2655-.06 1.6447-.072 4.848-.079 3.2033-.007 3.5835.005 4.8495.0608 1.169.0508 1.8053.2445 2.228.408.5608.216.96.4754 1.3816.895.4217.4194.6816.8176.9005 1.3787.1653.4217.3617 1.056.4169 2.2263.0602 1.2655.0739 1.645.0796 4.848.0058 3.203-.0055 3.5834-.061 4.848-.051 1.17-.245 1.8055-.408 2.2294-.216.5604-.4763.96-.8954 1.3814-.419.4215-.8181.6811-1.3783.9-.4224.1649-1.0577.3617-2.2262.4174-1.2656.0595-1.6448.072-4.8493.079-3.2045.007-3.5825-.006-4.848-.0608M16.953 5.5864A1.44 1.44 0 1 0 18.39 4.144a1.44 1.44 0 0 0-1.437 1.4424M5.8385 12.012c.0067 3.4032 2.7706 6.1557 6.173 6.1493 3.4026-.0065 6.157-2.7701 6.1506-6.1733-.0065-3.4032-2.771-6.1565-6.174-6.1498-3.403.0067-6.156 2.771-6.1496 6.1738M8 12.0077a4 4 0 1 1 4.008 3.9921A3.9996 3.9996 0 0 1 8 12.0077" />
            </svg>
          </a>
          <a href="https://www.linkedin.com/company/la-colonial-s.a.-compa-a-de-seguros"
            class="text-secondary text-decoration-none bg-danger d-flex p-0 pb-1 align-items-center justify-content-center rounded-circle"
            style="width: 34px; height: 34px;" target="_blank">
            <app-icon name="linkedin" [size]="18" [strokeWidth]="1.8" color="#fff"></app-icon>
          </a>
          <a href="https://twitter.com/LaColonialSeg"
            class="text-secondary text-decoration-none bg-danger d-flex p-0 align-items-center justify-content-center rounded-circle"
            style="width: 34px; height: 34px;" target="_blank">
            <svg role="img" viewBox="0 0 24 24" style="width: 18px; height:18px;" xmlns="http://www.w3.org/2000/svg">
              <title>X</title>
              <path fill="#fff"
                d="M14.234 10.162 22.977 0h-2.072l-7.591 8.824L7.251 0H.258l9.168 13.343L.258 24H2.33l8.016-9.318L16.749 24h6.993zm-2.837 3.299-.929-1.329L3.076 1.56h3.182l5.965 8.532.929 1.329 7.754 11.09h-3.182z" />
            </svg>
          </a>
        </div>
      </div>
      <div class="col">
        <p class="text-center text-secondary mb-1">
          También disponible en
        </p>
        <div class="d-flex flex-wrap align-items-center justify-content-center gap-3 mt-2">
          <a href="https://play.google.com/store/apps/details?id=com.lacolonial.lacolonialapp&hl=es_419" class="d-block"
            target="_blank">
            <img src="../../../../assets/img/google-play-badge.png" alt="Google Play Store" class=""
              style="height: 40px;">
          </a>
          <a href="https://apps.apple.com/do/app/la-colonial/id1483806130" class="d-block" target="_blank">
            <img src="../../../../assets/img/app-store-badge.png" alt="Apple App Store" class="" style="height: 40px;">
          </a>
          <a href="https://appgallery1.huawei.com/#/app/C102196837" class="d-block" target="_blank">
            <img src="../../../../assets/img/app-gallery-badge.png" alt="Apple App Store" class=""
              style="height: 40px;">
          </a>
        </div>
      </div>
      <div class="col">
        <p class="text-center text-secondary mb-1">
          Escríbenos a Whatsapp
        </p>
        <a href="https://api.whatsapp.com/send?phone=+18095088000&text=%C2%A1Hola!"
          class="d-flex text-decoration-none justify-content-center align-items-center gap-2 mt-2 mx-auto border rounded-pill py-1 px-2 small"
          style="width: fit-content;" target="_blank">
          <svg role="img" viewBox="0 0 24 24" style="width: 18px; height:18px;" width="24" height="24" fill="#268900"
            xmlns="http://www.w3.org/2000/svg">
            <title>WhatsApp</title>
            <path
              d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
          </svg>
          <span class="text-secondary fw-semibold">809.508.8000</span>
        </a>
      </div>
    </div>
  </div>
</footer>